function isElementInViewport (el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }
  
    var rect = el.getBoundingClientRect();
  
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= $(window).height() &&
        rect.right <= $(window).width()
    );
  }
  
  $(document).ready(function() {
      var atcOriginal = document.getElementById("atc-original");
      var floating = document.getElementById("floating-cta-bar");
      var $floating = $(floating);
  
      floating.style.display = "none";
  
      $(window).on("scroll", function() {
          var y = window.scrollY;
          var rect = atcOriginal.getBoundingClientRect();
          var offsetFromTop = rect.top + y;
  
          if (isElementInViewport(atcOriginal)) {
            $floating.fadeOut(80);
          } else if(y >= offsetFromTop) {
            $floating.fadeIn(250);
          }
      });
  })